"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubDocumentManipulator = void 0;
var tslib_1 = require("tslib");
var insert_sub_document_history_item_1 = require("../history/items/insert-sub-document-history-item");
var base_manipulator_1 = require("./base-manipulator");
var sub_document_inserter_1 = require("./document/sub-document-inserter");
var SubDocumentManipulator = (function (_super) {
    tslib_1.__extends(SubDocumentManipulator, _super);
    function SubDocumentManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubDocumentManipulator.prototype.insertSubDocument = function (targetSubDocPos, sourceInfo, options) {
        if (options === void 0) { options = new sub_document_inserter_1.SubDocumentInserterOptions(); }
        var historyItem = new insert_sub_document_history_item_1.InsertSubDocumentHistoryItem(this.modelManipulator, options, targetSubDocPos, sourceInfo);
        this.history.addAndRedo(historyItem);
        return {
            insetedInterval: historyItem.insertedInterval,
            newSubDocuments: historyItem.insertedSubDocuments
        };
    };
    return SubDocumentManipulator;
}(base_manipulator_1.BaseManipulator));
exports.SubDocumentManipulator = SubDocumentManipulator;
